import toArray from '../toArray';

import addClass from './addClass';
import hasClass from './hasClass';
import newClass from './newClass';
import removeClass from './removeClass';
import switchClass from './switchClass';
import toggleClass from './toggleClass';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        addClass(data: string): HTMLElement;
        hasClass(find: string): boolean;
        newClass(data: string): HTMLElement;
        removeClass(data: string): HTMLElement;
        switchClass(oldClass: string, newClass: string): HTMLElement;
        toggleClass(token: string, value?: boolean): boolean;
    }
    interface NodeList {
        addClass(data: string): NodeList;
        hasClass(find: string): boolean;
        newClass(data: string): NodeList;
        removeClass(data: string): NodeList;
        switchClass(oldClass: string, newClass: string): NodeList;
        toggleClass(token: string, value?: boolean): NodeList;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.addClass = function (data: string): HTMLElement {
    addClass(this, data);

    return this;
};

NodeList.prototype.addClass = function (data: string): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            addClass(element, data);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.hasClass = function (find: string): boolean {
    return hasClass(this, find);
};

NodeList.prototype.hasClass = function (find: string): boolean {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement && !hasClass(element, find)) {
            return false;
        }
    }

    return true;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.newClass = function (data: string): HTMLElement {
    newClass(this, data);

    return this;
};

NodeList.prototype.newClass = function (data: string): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            newClass(element, data);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.removeClass = function (data: string): HTMLElement {
    removeClass(this, data);

    return this;
};

NodeList.prototype.removeClass = function (data: string): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            removeClass(element, data);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.switchClass = function (oldClass: string, newClassName: string): HTMLElement {
    switchClass(this, oldClass, newClassName);

    return this;
};

NodeList.prototype.switchClass = function (oldClass: string, newClassName: string): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            switchClass(element, oldClass, newClassName);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.toggleClass = function (token: string, value?: boolean): boolean {
    return toggleClass(this, token, value);
};

NodeList.prototype.toggleClass = function (token: string, value?: boolean): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            toggleClass(element, token, value);
        }
    }

    return this;
};
